import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useDeleteProfile } from '@area-restrita/api-client/endpoints/profile/profile.gen';
import { toast } from 'react-toastify';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { Button } from '@/components/ui/button';
import { DialogClose, DialogFooter } from '@/components/ui/dialog';
import {
  Form,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { ApiError } from '@area-restrita/client';

const DeleteAccount: React.FC = () => {
  const { signOut } = useAuthSessionStore();
  const form = useForm({
    defaultValues: {
      password: '',
    },
    resolver: zodResolver(
      z.object({
        password: z.string().min(1, 'Senha é obrigatória'),
      }),
    ),
  });

  const { mutateAsync: deleteProfileMutate } = useDeleteProfile();

  return (
    <Form {...form}>
      <div className="flex flex-col gap-4">
        <p>
          Ao excluir sua conta, todos os seus vinculos, dados e informações
          serão removidos permanentemente.
        </p>

        <Controller
          control={form.control}
          name="password"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormLabel>Digite sua senha para confirmar</FormLabel>
              <FormControl>
                <Input
                  placeholder="Digite sua senha"
                  type="password"
                  {...field}
                />
              </FormControl>
              <FormMessage>{fieldState.error?.message}</FormMessage>
            </FormItem>
          )}
        />

        <DialogFooter>
          <DialogClose asChild>
            <Button type="reset" variant="secondary">
              Cancelar
            </Button>
          </DialogClose>

          <Button
            variant="destructive"
            onClick={form.handleSubmit((data) =>
              deleteProfileMutate(
                { data },
                {
                  onSuccess: () => {
                    toast.success('Conta excluída com sucesso');
                    signOut();
                  },
                  onError: (error) => {
                    if (error instanceof ApiError && error.statusCode === 400) {
                      form.setError(
                        'password',
                        {
                          type: 'manual',
                          message: 'Senha inválida',
                        },
                        { shouldFocus: true },
                      );

                      return;
                    }

                    toast.error('Erro ao excluir conta');
                  },
                },
              ),
            )}
          >
            Excluir conta
          </Button>
        </DialogFooter>
      </div>
    </Form>
  );
};

export default DeleteAccount;
